<page-header titleText="Invoices"> </page-header>
<div class="container-fluid page-container">
    <card>
        <div right-header-content class="invoices-filters">
            <form class="invoices-filters" [formGroup]="filtersFormGroup">
                <div class="invoice-status-filter">
                    <lsq-select
                        *ngIf="filterOptions"
                        [name]="'prospect-filter-select'"
                        [options]="filterOptions"
                        [group]="filtersFormGroup"
                        formControlName="invoiceStatusFilter"
                        (ngModelChange)="handleFilterChange()"
                    >
                    </lsq-select>
                </div>
                <div>
                    <lsq-input
                        i18n-placeholder
                        placeholder="Search Invoices"
                        formControlName="invoiceSearch"
                        [name]="'invoiceSearch'"
                        [prependIcon]="[icons.FaMagnifyingGlassSolid, color.GraphicGray]"
                        [group]="filtersFormGroup"
                        (ngModelChange)="handleFilterChange()"
                    >
                    </lsq-input>
                </div>
            </form>
        </div>
        <div card-body>
            <lsq-data-table
                *ngIf="!!tableDataSource"
                [hasHeader]="true"
                [isPaginated]="true"
                [layoutFixed]="true"
                [dataSource]="tableDataSource"
            >
                <lsq-column
                    [column]="{
                        header: 'Buyer',
                        key: 'buyerName',
                        width: '10%',
                        sortable: true
                    }"
                >
                    <ng-template [custom-cell] let-row="row">
                        <lsq-smart-truncate [value]="row.buyerName"></lsq-smart-truncate>
                    </ng-template>
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Supplier',
                        key: 'supplierName',
                        width: '10%',
                        sortable: true
                    }"
                >
                    <ng-template [custom-cell] let-row="row">
                        <lsq-smart-truncate [value]="row.supplierName"></lsq-smart-truncate>
                    </ng-template>
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Invoice Number',
                        key: 'invoiceNumber',
                        sortable: true
                    }"
                >
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Invoice Date',
                        key: 'invoiceDate',
                        sortable: true
                    }"
                >
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Adj. Due Date',
                        key: 'adjustDueDate',
                        sortable: true
                    }"
                >
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Raw Due Date',
                        key: 'dueDate',
                        sortable: true
                    }"
                >
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Invoice Status',
                        key: 'status',
                        sortable: true
                    }"
                >
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Funds Sent',
                        key: 'fundsSent',
                        sortable: true
                    }"
                >
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Post Date',
                        key: 'postDate',
                        sortable: true
                    }"
                >
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Payment Date',
                        key: 'paymentDate',
                        sortable: true
                    }"
                >
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Payment ID',
                        key: 'paymentId',
                        sortable: true
                    }"
                >
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Payment Amount',
                        key: 'paymentAmount',
                        sortable: true
                    }"
                >
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'FBO Status',
                        key: 'fboStatus',
                        sortable: true
                    }"
                >
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Collection Updated',
                        key: 'collectionUpdated',
                        sortable: true
                    }"
                >
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Collection Created',
                        key: 'collectionCreated',
                        sortable: true
                    }"
                >
                </lsq-column>
            </lsq-data-table>
        </div>
    </card>
</div>
